export class timezoneSelector {
  constructor(moment) {

    $(document).ready(function () {
      let zones = {};
      let zone = moment.tz.guess();
      let locale = $("html").attr("lang") || "en";
      let fn = function () {
        $('.product-schedule').each(function (el) {
          let start = moment.utc($(this).data('start'));
          let end = moment.utc($(this).data('end'));
          $('.date', this).html(moment.tz(start, zone).locale(locale).format('ll'));
          $('.time', this).html(moment.tz(start, zone).locale(locale).format('LT') + ' - ' + moment.tz(end, zone).locale(locale).format('LT z'));
        });
      };
      fn();

      if ($('#timezones').length) {
        let locale = $('#timezones').data('locale');
        moment.tz.names().forEach(function (name) {
          let parts = name.split('/');
          if (['Africa', 'America', 'Asia', 'Atlantic', 'Australia', 'Europe', 'Indian', 'Pacific'].includes(parts[0])) {
            if (!zones[parts[0]]) {
              zones[parts[0]] = {};
            }
            zones[parts[0]][parts[1].replace('_', ' ')] = name;
          }
        });
        try {
          if (window.sessionStorage) {
            zone = window.sessionStorage.getItem('timezone') || zone;
          }
        } catch (e) {
        }
        let html = '<option value="' + zone + '">' + zone + '</option>';
        for (const continent in zones) {
          html += '<optgroup label="' + continent + '">';
          for (const name in zones[continent]) {
            html += '<option value="' + zones[continent][name] + '">' + name + '</option>';
          }
          html += '</optgroup>';
        }
        $('#timezones').html(html);
        $('#timezones').on('change', function () {
          try {
            if (window.sessionStorage) {
              window.sessionStorage.setItem('timezone', this.value);
            }
          } catch (e) {
          }
          zone = this.value;
          fn();
        });
      }
    });

  }
}
